<template>
  <div
    class="loading-container w-100 h-100 d-flex justify-content-center align-items-center"
  >
    <b-spinner
      style="width: 4rem; height: 4rem"
      variant="primary"
      label="Spinning"
    />
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay"
};
</script>

<style scoped>
.loading-container {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(233, 236, 239, 0.8) !important;
}
</style>
